import { Spin } from '@weapp/ui';

function Loading(props: any) {
  return (
    <Spin size="large" weId={`${props.weId || ''}_ndzvnt`}><div style={{ width: '100vw', height: '100vh' }}></div></Spin>
  );
}

export default Loading;